// @ts-ignore
import {combineReducers, Reducer} from 'redux';
// @ts-ignore
import * as ramda from 'ramda';
import type {AccountId, ListItem} from '../types';
import {reduceListItemsByEntityId} from '../list-items/list-items-utils';
import * as Contacts from '../contacts';
import {addItemsToByIdState} from '../reducer-utils';
// @ts-ignore
import {Account, AccountFormValues} from './accounts-types';
// @ts-ignore
import {ActionTypes, AccountsAction} from './accounts-actions';

/*
 * `byId`
 */
type ByIdState = AccountsState['byId'];
const byIdReducer = (
    state: ByIdState | null | undefined = {},
    action: Contacts.ContactsAction | AccountsAction
): ByIdState => {
    switch (action.type) {
        case ActionTypes.ACCOUNTS_FETCH_BY_ID_SUCCESS:
        case Contacts.ActionTypes.CONTACTS_FETCH_BY_ID_SUCCESS: {
            if (action.payload.accounts) {
                // @ts-ignore
                return addItemsToByIdState(action.payload.accounts, state);
            }

            // @ts-ignore
            return state;
        }
        default:
            // @ts-ignore
            return state;
    }
};

/*
 * `tempByName`
 *
 * This maintains a list of new accounts which haven't been created within Nutshell.
 */

type TempByNameState = AccountsState['tempByName'];
const tempByNameReducer = (
    state: TempByNameState | null | undefined = {},
    action: Contacts.ContactsAction | AccountsAction
): TempByNameState => {
    switch (action.type) {
        case ActionTypes.ACCOUNTS_ACCOUNT_QUEUED_FOR_CREATION:
            return {...state, [action.payload.name.toLowerCase()]: action.payload};
        case ActionTypes.ACCOUNTS_ACCOUNT_UNQUEUED_FOR_CREATION:
            return ramda.omit([action.payload], state);
        case ActionTypes.ACCOUNTS_QUEUED_ACCOUNTS_CLEARED:
            return {};
        default:
            // @ts-ignore
            return state;
    }
};

/*
 * `listItems`
 */
type ListItemsState = Partial<Record<AccountId, ListItem>>;
const listItemsByIdReducer = (
    state: ListItemsState | null | undefined = {},
    action: AccountsAction
): ListItemsState => {
    switch (action.type) {
        case ActionTypes.ACCOUNTS_FETCH_LIST_SUCCESS: {
            return reduceListItemsByEntityId({...state}, action.payload.listItems);
        }
        default:
            // @ts-ignore
            return state;
    }
};

export type AccountsState = {
    byId: Partial<Record<AccountId, Account>>;
    tempByName: {
        [name: string]: AccountFormValues;
    };
    listItemsById: ListItemsState;
};

// @ts-ignore
export const reducer: Reducer<AccountsState, Contacts.ContactsAction | AccountsAction> =
    combineReducers({
        byId: byIdReducer,
        tempByName: tempByNameReducer,
        listItemsById: listItemsByIdReducer,
    });
